// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';
// import GlobalStyle from './styles/globalStyles';
import { WebSocketProvider } from './contexts/WebSocketContext';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <WebSocketProvider>
      <ThemeProvider>
        <ScrollToTop />
        <StyledChart />
        {/* <GlobalStyle /> */}
        <Router />
      </ThemeProvider>
    </WebSocketProvider>
  );
}
